import { apiClient } from "./client";
import type {
  Group,
  GroupCreate,
  GroupUpdate,
  GroupsPaginated,
  MessageResponse,
} from "@/types";

export async function listGroups(search?: string): Promise<GroupsPaginated> {
  const response = await apiClient.get<GroupsPaginated>("/groups", {
    params: search ? { search } : undefined,
  });
  return response.data;
}

export async function getGroup(groupId: number): Promise<Group> {
  const response = await apiClient.get<Group>(`/groups/${groupId}`);
  return response.data;
}

export async function createGroup(data: GroupCreate): Promise<Group> {
  const response = await apiClient.post<Group>("/groups", data);
  return response.data;
}

export async function updateGroup(groupId: number, data: GroupUpdate): Promise<Group> {
  const response = await apiClient.patch<Group>(`/groups/${groupId}`, data);
  return response.data;
}

export async function deleteGroup(groupId: number): Promise<MessageResponse> {
  const response = await apiClient.delete<MessageResponse>(`/groups/${groupId}`);
  return response.data;
}
